/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { ReactNode } from 'react';
import { ExitHandler } from 'react-transition-group/Transition';
import { SdsDivProps } from '../Component.props';
import { TransitionType } from './SdsTransition.types';

/**
 * The props for `<SdsTransition />`.
 */
export interface SdsTransitionProps extends SdsDivProps {
  /**
   * The elements to transition.
   */
  children: ReactNode;

  /**
   * The custom callback to run when the transition ends.
   */
  exitCallback: ExitHandler<HTMLElement>;

  /**
   * The flag to define transition start and stop.
   */
  isActive: boolean;

  /**
   * The transition delay in ms.
   */
  timeout?: number;

  /**
   * The transition type effect.
   */
  transitionType?: TransitionType;
}

/**
 * The default prop values for `<SdsTransition />`.
 */
export const sdsTransitionDefaults = {
  timeout: 600,
};
